export default __webpack_public_path__ + "static/intro-circle-f9455689f002620517d691016937f9f8.svg";